// The one environment probe `@sl/core/messages` makes (T-020; its own leaf since T-322 so `keys.ts` can ask it
// without importing the renderer). Imports nothing.

/** Development when React Native's `__DEV__` says so, else when Node's NODE_ENV is not `production`; a browser
 *  without either (a Vite bundle) is treated as production — the app passes `strict: import.meta.env.DEV`. */
export function detectDev(): boolean {
  const g = globalThis as {
    __DEV__?: unknown;
    process?: { env?: Record<string, string | undefined> };
  };
  if (typeof g.__DEV__ === 'boolean') return g.__DEV__;
  const nodeEnv = g.process?.env?.NODE_ENV;
  if (typeof nodeEnv === 'string') return nodeEnv !== 'production';
  return false;
}
